// extracted by mini-css-extract-plugin
export default {"user__mood":"UserMood_user__mood__Hmci3","user__activeMood":"UserMood_user__activeMood__FCQBD"};